module.exports = __webpack_public_path__ + "static/media/4H.6695f1d5.png";